<template>
		<page>
			<router-view />
		</page>
</template>

<script>

import Page from '../../components/layout/Page';

export default {
	name: 'MagTemplateLayout',
	components: {
		Page
	}
};
</script>

<style scoped>

</style>
